import {
	OctAutocompleteObject,
	OctDatePickerCustom,
	OctInputSearch,
	OctLabel,
	OctTextField
} from "@oceantech/oceantech-ui";
import { ChangeEvent, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import OctPopover from "../../component/popover";
import SignButton from "./SignButton";

type Props = {
	onSearch: (query: any) => void;
};

const SignatureFilter = ({ onSearch }: Props) => {
	const [value, setValue] = useState<any>(null);

	const onFilter = () => {
		onSearch(value);
	};

	const onFilterClear = () => {
		setValue(null);
	};

	return (
		<div>
			<div className="d-flex justify-content-end spaces py-8 gap-8">
				<SignButton />
				<div className="w-25">
					<OctInputSearch
						onChange={(inputValue) => {
							if (inputValue === value?.keyword) return;

							onSearch({
								keyword: inputValue,
							});
						}}
						handleSearch={() => {
							onSearch(value);
						}}
						placeholder="Tìm kiếm theo họ tên,mã bệnh nhân"
					/>
				</div>
				<OctPopover
					buttonProps={{
						className: "btn-fill",
						children: (
							<>
								<i className="bi bi-funnel me-0"></i>
								Tìm kiếm nâng cao
								{value && Object.keys(value).length && (
									<span className="badge badge-circle badge-warning spaces w-20 h-20 ml-4">
										{Object.keys(value).length}
									</span>
								)}
							</>
						),
					}}
					overlayProps={{
						placement: "bottom",
					}}
					popoverProps={{
						style: {
							minWidth: "30vw",
						},
					}}
				>
					<div className="flex-column spaces gap-4">
						<Row>
							<Col>
								<OctLabel label="Loại hồ sơ" />
								<OctAutocompleteObject
									options={[]}
									name="type"
									value={value?.type}
									onChange={(selectedOption) => {
										setValue({
											...value,
											type: selectedOption,
										});
									}}
								/>
							</Col>
							<Col>
								<OctLabel label="Người ký" />
								<OctTextField
									name="signBy"
									value={value?.signBy}
									onChange={(e: ChangeEvent<HTMLInputElement>) => {
										setValue({
											...value,
											signBy: e.target.value,
										});
									}}
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<OctLabel label="Người tạo" />
								<OctTextField
									name="createdBy"
									value={value?.createdBy}
									onChange={(e: ChangeEvent<HTMLInputElement>) => {
										setValue({
											...value,
											createdBy: e.target.value,
										});
									}}
								/>
							</Col>
							<Col>
								<OctLabel label="Ngày tạo" />
								<OctDatePickerCustom
									name="createdDate"
									value={value?.createdDate}
									onChange={(dateValue) => {
										setValue({
											...value,
											createdDate: dateValue,
										});
									}}
									popperPlacement="left"
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<OctLabel label="Ngày vào viện" />
								<OctDatePickerCustom
									name="dateIn"
									value={value?.dateIn}
									onChange={(dateValue) => {
										setValue({
											...value,
											dateIn: dateValue,
										});
									}}
									popperPlacement="left"
								/>
							</Col>
							<Col>
								<OctLabel label="Ngày ra viện" />
								<OctDatePickerCustom
									name="dateOut"
									value={value?.dateOut}
									onChange={(dateValue) => {
										setValue({
											...value,
											dateOut: dateValue,
										});
									}}
									popperPlacement="left"
								/>
							</Col>
						</Row>
						<Row>
							<Col>
								<OctLabel label="Trạng thái" />
								<OctAutocompleteObject
									options={[]}
									name="status"
									value={value?.type}
									onChange={(selectedOption) => {
										setValue({
											...value,
											status: selectedOption,
										});
									}}
								/>
							</Col>
						</Row>
						<div className="d-flex justify-content-center spaces gap-4 mt-8">
							<Button className="btn-danger spaces px-16" onClick={onFilterClear}>
								Làm mới
							</Button>
							<Button className="btn-fill spaces px-16" onClick={onFilter}>
								Lọc
							</Button>
						</div>
					</div>
				</OctPopover>
			</div>
		</div>
	);
};

export default SignatureFilter;
